export function initModal() {
  const overlay = document.getElementById('avionics-modal-overlay');
  const closeBtn = document.getElementById('avionics-modal-close');
  const form = document.getElementById('avionics-clearance-form');
  
  const modalBadge = document.getElementById('modal-badge');
  const modalHeadline = document.getElementById('modal-headline');
  const modalSubtitle = document.getElementById('modal-subtitle');
  const modalSubmitBtn = document.getElementById('modal-submit-btn');
  const requestTypeInput = document.getElementById('modal-request-type');
  
  const contentForm = document.getElementById('modal-content-form');
  const contentSuccess = document.getElementById('modal-content-success');
  const modalFormStatus = document.getElementById('modal-form-status');

  if (!overlay || !form) return;

  function openModal(triggerType) {
    // Reset state
    contentForm.style.display = 'block';
    contentSuccess.style.display = 'none';
    if (modalFormStatus) {
      modalFormStatus.style.display = 'none';
      modalFormStatus.textContent = '';
    }
    form.reset();
    modalSubmitBtn.querySelector('span').textContent = 'Request \u2192';

    // Populate dynamic payload
    if (triggerType === 'Executive CV') {
      if (modalBadge) modalBadge.style.display = 'none';
      modalHeadline.textContent = 'REQUEST CV';
      modalSubtitle.textContent = 'Direct dispatch of verified case metrics, technical stack index, and performance background.';
      modalSubmitBtn.querySelector('span').textContent = 'Request CV \u2192';
      requestTypeInput.value = 'Executive CV';
    } else if (triggerType === 'Complete Stack Index') {
      if (modalBadge) modalBadge.style.display = 'none';
      modalHeadline.textContent = 'REQUEST ARSENAL BLUEPRINT';
      modalSubtitle.textContent = 'Complete index of automation webhooks, serverless edge routes, and Meta CAPI pipelines.';
      modalSubmitBtn.querySelector('span').textContent = 'Request Stack Blueprint \u2192';
      requestTypeInput.value = 'Complete Stack Index';
    }

    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden'; // Lock background scroll
    
    // Focus trap
    setTimeout(() => {
      document.getElementById('modal-name')?.focus();
    }, 100);
  }

  function closeModal() {
    overlay.classList.remove('is-active');
    document.body.style.overflow = ''; // Unlock background scroll
  }

  // Bind Open Triggers
  document.querySelectorAll('.btn-talon').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const text = btn.textContent.trim().toUpperCase();
      if (text.includes('REQUEST MY CV')) {
        e.preventDefault();
        openModal('Executive CV');
      } else if (text.includes('REQUEST COMPLETE STACK INDEX')) {
        e.preventDefault();
        openModal('Complete Stack Index');
      }
    });
  });

  // Bind Close Triggers
  closeBtn.addEventListener('click', closeModal);

  const successCloseBtn = document.getElementById('modal-success-close-btn');
  if (successCloseBtn) {
    successCloseBtn.addEventListener('click', closeModal);
  }
  
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.classList.contains('is-active')) {
      closeModal();
    }
  });

  // Form Submission
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btnSpan = modalSubmitBtn.querySelector('span');

    modalSubmitBtn.disabled = true;
    btnSpan.textContent = 'DISPATCHING REQUEST...';
    if (modalFormStatus) {
      modalFormStatus.style.display = 'none';
      modalFormStatus.textContent = '';
    }
    
    const formData = new FormData(form);
    const tToken = formData.get('cf-turnstile-response') || (window.turnstile ? window.turnstile.getResponse() : '');
    
    if (!tToken) {
      if (modalFormStatus) {
        modalFormStatus.style.display = 'block';
        modalFormStatus.textContent = 'Please complete the security check before submitting.';
      }
      modalSubmitBtn.disabled = false;
      btnSpan.textContent = 'Request CV \u2192';
      return;
    }

    const reqType = requestTypeInput.value;
    const payload = {
      name: formData.get('name') || '',
      contact: formData.get('contact') || '',
      role: formData.get('role_org') || '',
      requestType: reqType,
      turnstileToken: tToken
    };

    console.log("Submitting lead payload with token:", payload.turnstileToken);

    try {
      const { sendTelegramAlert } = await import('./telegram.js');
      await sendTelegramAlert('CV_REQUEST', payload);

      // Success Transition
      contentForm.style.display = 'none';
      contentSuccess.style.display = 'block';

      form.reset();

      // Reset Turnstile
      if (window.turnstile) {
        try { window.turnstile.reset(); } catch(e) {}
      }

      // Fire GTM event if available
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'lead_clearance_submitted',
        type: reqType
      });
    } catch (err) {
      console.error('🚨 CV Modal Submission Failed. Exact error details:', err);
      btnSpan.textContent = 'Request Failed - Retry';
      if (modalFormStatus) {
        modalFormStatus.style.display = 'block';
        modalFormStatus.textContent = err.message || 'Transmission failed. Check console for details.';
      }
    } finally {
      modalSubmitBtn.disabled = false;
    }
  });
}
